import types from 'actions/types'
import {combineReducers} from 'redux'

const notifications = (state = [], action) => {
  switch (action.type) {
    case types.NOTIFICATIONS_LOAD_SUCCESS:
      return action.notifications || []
    case types.NOTIFICATIONS_SNOOZE_ATTEMPT:
    case types.NOTIFICATIONS_DISMISS_ATTEMPT:
      return [...state.filter(n => n.id !== action.id)]
    case types.NOTIFICATIONS_DISMISS_ALL_ATTEMPT:
      return []
    case types.UI_NOTIFICATION_DUE:
      return [...state, action]
    default:
      return state
  }
}

const hidden = (state = [], action) => {
  switch (action.type) {
    case types.NOTIFICATION_HIDE:
      return [...state.filter(n => n !== action.id), action.id]
    case types.NOTIFICATIONS_SNOOZE_ATTEMPT:
    case types.NOTIFICATIONS_DISMISS_ATTEMPT:
      return [...state.filter(n => n !== action.id)]
    case types.NOTIFICATIONS_DISMISS_ALL_ATTEMPT:
      return []
    default:
      return state
  }
}

export default combineReducers({
  notifications,
  hidden,
})
